/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListThemes = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-list-themes_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-list-themes_svg__st0"
      d="M12 16c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
    />
    <path
      className="ico-list-themes_svg__st0"
      d="m4 14.6-2.9 7 1.8.8L5.6 16h4.5v-2H6.5L10 5.6l4.1 9.8 1.8-.8L10 .4zM17 18h4v2h-4z"
    />
  </Icon>
);
export { SvgListThemes as ListThemes };
